/* import __COLOCATED_TEMPLATE__ from './learn-content-suggestion.hbs'; */
/* RESPONSIBLE TEAM: team-conversational-knowledge */

import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type IntlService from 'ember-intl/services/intl';
import { openTutorial } from 'embercom/helpers/open-tutorial';

type DropdownItem = {
  text: string;
  icon: string;
  onSelectItem: () => void;
};

export default class LearnContentSuggestion extends Component {
  @service declare router: any;
  @service declare intl: IntlService;
  @service declare appService: AppService;
  @service declare modalService: $TSFixMe;

  get groupList() {
    return [
      {
        items: this.items,
      },
    ];
  }

  get items() {
    if (this.appService.app.canUseStandalone) {
      return this.standaloneItems;
    } else {
      return this.platformItems;
    }
  }

  get standaloneItems() {
    let items: DropdownItem[] = [];
    if (this.appService.app.canUseAiInsightsSuggestionsUi) {
      items.push(this.standaloneSuggestionsForFinHCLink);
    } else {
      items.push(this.standaloneConverastionExtractionHCLink);
    }
    items.push(this.optimizeContentForFinHCLink);
    return items;
  }

  get platformItems() {
    let items: DropdownItem[] = [];
    if (this.appService.app.canUseAiInsightsSuggestionsUi) {
      items.push(this.platformSuggestionsForFinHCLink, this.notificationSettingsLink);
    } else {
      items.push(
        this.platformConversationExtractionHCLink,
        this.configureConversationExtractionLink,
      );
    }

    items.push(this.finTurorialLink);
    return items;
  }

  get configureConversationExtractionLink() {
    return {
      text: this.intl.t('ai-content-library.learn-dropdown.configure-content-suggestions'),
      icon: 'settings',
      onSelectItem: this.redirectToConfigureContentSuggestions,
    };
  }

  get finTurorialLink() {
    return {
      text: this.intl.t('ai-content-library.learn-dropdown.banner.add-content-get-going'),
      icon: 'education',
      onSelectItem: this.openFinTutorial,
    };
  }

  get notificationSettingsLink() {
    return {
      text: this.intl.t('ai-content-library.learn-dropdown.manage-notifications'),
      icon: 'settings',
      onSelectItem: this.redirectToNotificationSettings,
    };
  }

  get platformSuggestionsForFinHCLink() {
    return {
      text: this.intl.t('ai-content-library.learn-dropdown.use-suggestions-to-improve-fin'),
      icon: 'article',
      onSelectItem: () => window.Intercom('showArticle', 11394959),
    };
  }

  get standaloneSuggestionsForFinHCLink() {
    return {
      text: this.intl.t('ai-content-library.learn-dropdown.use-suggestions-to-improve-fin'),
      icon: 'article',
      onSelectItem: () => window.Intercom('showArticle', 11420114),
    };
  }

  get platformConversationExtractionHCLink() {
    return {
      text: this.intl.t('ai-content-library.learn-dropdown.using-conversation-content-with-fin'),
      icon: 'article',
      onSelectItem: () => window.Intercom('showArticle', 10260362),
    };
  }

  get standaloneConverastionExtractionHCLink() {
    return {
      text: this.intl.t('ai-content-library.learn-dropdown.using-conversation-content-with-fin'),
      icon: 'article',
      onSelectItem: () => window.Intercom('showArticle', 10727368),
    };
  }

  get optimizeContentForFinHCLink() {
    return {
      text: this.intl.t('ai-content-library.learn-dropdown.optimizing-content-for-fin'),
      icon: 'article',
      onSelectItem: () => window.Intercom('showArticle', 10625127),
    };
  }

  @action
  openFinTutorial() {
    openTutorial('2', 'suggestions', 'learn_dropdown', this.modalService);
  }

  @action
  redirectToConfigureContentSuggestions() {
    this.router.transitionTo('apps.app.automation.fin-ai-agent.content', {
      queryParams: { openSectionId: 'conversation-content' },
    });
  }

  @action
  redirectToNotificationSettings() {
    this.router.transitionTo('apps.app.account.notifications');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'ContentService::LearnDropdown::LearnContentSuggestion': typeof LearnContentSuggestion;
  }
}
